import { Component, Output, EventEmitter, Inject } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { FerrerAuthService } from 'app/services/authentication.service';
import { NavigationFlowService } from 'app/services/navigation-flow.service';
import { firstValueFrom } from 'rxjs';
import { OtpSuggestDialogComponent } from 'app/modules/dialogs/otp-suggest/otpsuggestpwd-dialog.component';

@Component({
  selector: 'app-blocked-medical',
  templateUrl: './non_medical.component.html',
  imports: [
    TranslocoPipe,
    FormsModule,
    MatIconModule,
    CommonModule
  ],
})
export class BlockedMedicalComponent {
  @Output() next = new EventEmitter<void>();
  email = '';
  otpCode = '';
  password = '';
  isLoading = false;
  constructor(
    private translocoService: TranslocoService,
    private _dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private ferrerAuth: FerrerAuthService,
    private dialogUtilsService: DialogUtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private navigationFlow: NavigationFlowService
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    this.email = this.data.email || '';
    if (this.data.otpCode) {
      this.otpCode = this.data.otpCode;
    } else if (this.data.password) {
      this.password = this.data.password;
    }
  }
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }

  continue() {
    if (this.email) this.next.emit();
  }
  closeDialog(): void {
    this.dialogUtilsService.closeDialog(this._dialogRef);
  }

  async openLoginDialog(): Promise<void> {
    // Use NavigationFlowService to open login dialog
    await firstValueFrom(this.navigationFlow.openLoginDialog());
  }

  loginAgain(): void {
    this.ferrerAuth.login(this.email, this.password, this.otpCode)
      .subscribe({
        next: (response) => {

          this.isLoading = false;
          if (response && response.userAccess?.success === true) {
            // variara segun el contenido
            if (this.otpCode) {
              this.openpwdChangeDialog(response);
              return;
            }
            const isInIframe = this.isRunningInIframe();
            if (isInIframe) {
              // We're in an iframe, post message to parent
              if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                  type: 'loginSuccess',
                  userData: {
                    email: this.email
                  }
                }, '*');
              }
            } else {
              // Not in an iframe, open in new tab
              this._dialogRef.close("response");

              // Navigate to the returnUrl in the same tab
              window.location.href = response.returnUrl;


            }
            // Close the dialog
            this._dialogRef.close("response");
          } else {
            this.isLoading = false;

            this.handleApiError(response);
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.handleApiError(err);
        }
      });
  }

  private isRunningInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If we get a security error, we're definitely in an iframe
      return true;
    }
  }
  handleApiError(error: any): void {

    // Get error response body
    const errorBody = error.error.message || error.error || error;
    //this.apiError = errorBody;
  }
  shouldShowCloseButton(): boolean {
    const apiVersion = JSON.parse(localStorage.getItem('ferrerSessionData'));
    return this.dialogUtilsService.shouldShowCloseButton();
  }
  openpwdChangeDialog(response?: any): void {
    if (this._dialogRef) {
      this._dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(OtpSuggestDialogComponent, {
      width: `${width}px`,
      //height: `${height}px`,
      maxWidth: '90vw',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      data: {
        apiResponse: response,
        email: this.email
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }
}